<script setup lang="ts">
import { ArrowDownToLineIcon } from 'lucide-vue-next'
import { type Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

import { useOwnershipDataQuery } from '~~/src/composables/query/elementals/useOwnershipDataQuery'
import { useSidebarStore } from '~~/src/stores/sidebar'

const props = defineProps<{
  elemental: Elemental
  isJson?: boolean
  isTable?: boolean
}>()

const { goToExport } = useSidebarStore()

const { data: ownershipData, isLoading: isLoadingOwnershipData } = useOwnershipDataQuery({
  id: props.elemental?.id,
}, {
  enabled: props.elemental.isPremium,
})

const user = useUser()
const isOwner = computed(() => user.value?.id === props.elemental.user.id)
const handlerGetKnowledgeBase = async () => {
  goToExport(
    {
      ...props.elemental,
      elemental_type_id: props.elemental.isList ? ElementalTypeEnum.List : props.elemental.elementalTypeId!,
    },
  )
}
</script>

<template>
  <DropdownMenuItem :disabled="elemental.isPremium && (isLoadingOwnershipData || (!ownershipData?.isBought && !isOwner))" @click="handlerGetKnowledgeBase">
    <ArrowDownToLineIcon />
    Download Knowledge Base
  </DropdownMenuItem>
</template>
